/*

export interface TableFeature<TData extends RowData = any> {
  createCell?: (
    cell: Cell<TData, unknown>,
    column: Column<TData>,
    row: Row<TData>,
    table: Table<TData>
  ) => void
  createColumn?: (column: Column<TData, unknown>, table: Table<TData>) => void
  createHeader?: (header: Header<TData, unknown>, table: Table<TData>) => void
  createRow?: (row: Row<TData>, table: Table<TData>) => void
  createTable?: (table: Table<TData>) => void
  getDefaultColumnDef?: () => Partial<ColumnDef<TData, unknown>>
  getDefaultOptions?: (
    table: Table<TData>
  ) => Partial<TableOptionsResolved<TData>>
  getInitialState?: (initialState?: InitialTableState) => Partial<TableState>
}

*/

export const IdHeaderFeature = {
    // prefer id over accessorKey for default header
    // this means we can use a "nice" value for id and
    // header components/CSV can just use id as the header value
    getDefaultColumnDef() {
        return {
            header: (props) => {
                const { id, accessorKey } = props.header.column.columnDef;
                return id ?? accessorKey;
            },
        };
    },
};
